<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{titolo}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.close()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="formUtente">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="nome">Password</label>
                    <input type="text" class="form-control" formControlName="password" id="password" placeholder="Password">
                </div>
            </div>
        </div>
        
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">
        Chiudi
    </button>
    <button type="button" class="btn btn-primary" (click)="close()">Salva</button>
</div>